var render = function render(){var _vm=this,_c=_vm._self._c;return _c('paginate',{attrs:{"page-count":_vm.numberOfPages,"click-handler":_vm.changePage,"prev-text":"Précédent","next-text":"Suivant","container-class":"pagination"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }